/**
 * Home.jsx
 * src/pages/user/Home.jsx
 *
 * Main user-facing home page for BrightSmile Dental Clinic.
 *
 * Components used:
 *   Header              → sticky nav + Book Appointment button
 *   HeroCarousel        → full-screen carousel with 3 slides
 *   Overview            → clinic overview + why choose us
 *   Services            → 8 dental services grid
 *   Timing              → clinic hours + contact info
 *   Footer              → simple clean footer
 *
 * Usage in App.jsx:
 *   import Home from './pages/user/Home';
 *   <Route path="/" element={<Home />} />
 *
 * Install:
 *   npm install bootstrap
 *   In main.jsx → import 'bootstrap/dist/css/bootstrap.min.css'
 */

import { useState } from "react";

import Header           from "../../components/user/Header";
import HeroCarousel     from "../../components/user/HeroCarousel";
import Overview         from "../../components/user/Overview";
import Services         from "../../components/user/Services";
import Timing           from "../../components/user/Timing";
import Footer           from "../../components/user/Footer";
import BookAppointmentModal from "../../components/user/BookAppointmentModal";

export default function Home() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      {/* Global font */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; }
        html { scroll-behavior: smooth; }
        body { margin: 0; padding: 0; }
      `}</style>

      {/* ── HEADER ── */}
      <Header onBookClick={() => setModalOpen(true)} />

      {/* ── SECTION 1: Hero Carousel ── */}
      <HeroCarousel onBookClick={() => setModalOpen(true)} />

      {/* ── SECTION 2: Overview ── */}
      <Overview />

      {/* ── SECTION 3: Services ── */}
      <Services onBookClick={() => setModalOpen(true)} />

      {/* ── SECTION 4: Timing ── */}
      <Timing onBookClick={() => setModalOpen(true)} />

      {/* ── FOOTER ── */}
      <Footer />

      {/* ── Book Appointment Modal (shared) ── */}
      <BookAppointmentModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}